import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import Navbar from "./Shared/Components/ScrollToTop/Navbar/Navbar";
import ScrollToTop from "./Shared/Components/ScrollToTop/ScrollToTop";  
import HeroSection from "./Shared/Components/Hero/Hero";
import BooksSection from "./Shared/Components/BookSection/BooksSection";
import FeaturesStack from './Shared/Components/FeaturesStack/FeaturesStack';
import BestSeller from './Shared/Components/BestSeller/BestSeller';
import Services from './Shared/Components/Services/Services';
import Footer from './Shared/Components/Footer/Footer';
import { Route, Routes } from 'react-router-dom';
import SettingPage from './Shared/Routes/Settings/SettingPage';
import CopyRight from './Shared/Components/CopyRight/CopyRight';
function App() {

  
   const {i18n } = useTranslation();
  
  useEffect(() => {
    const isArabic = i18n.language === "ar";

    document.documentElement.lang = isArabic ? "ar" : "en";
    document.documentElement.dir = isArabic ? "rtl" : "ltr";

    document.body.classList.toggle("lang-ar", isArabic);
    document.body.classList.toggle("lang-en", !isArabic);
  }, [i18n.language]);

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <Services />
              <BooksSection />
              <FeaturesStack />
              <BestSeller />
            </>
          }
        />

        <Route
          path="/privacy"
          element={<SettingPage endpoint="privacy" title="Privacy Policy" />}
        />
        <Route
          path="/terms"
          element={<SettingPage endpoint="terms" title="Terms Of Service" />}
        />
        <Route
          path="/about-us"
          element={<SettingPage endpoint="about-us" title="About Us" />}
        />
      </Routes>
      <Footer />
      <CopyRight />
    </div>
  );
}

export default App;
